module.exports = __webpack_public_path__ + "static/media/virtualpos.58624a52.png";